export default {
  name: 'lastUpdate',
  methods: {
    disparar: disparar,
  },
}
function disparar (date, str = '') {
  try {
    if (date) {
      this.$root.$emit('updated', str + date.toLocaleDateString('pt-Br'))
    }
  } catch (error) {
    console.error('Parametro não é um tipo Date')
  }
}
